/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Ai_MachineInputs */

const cs_locale_ai_machine = /** @type {(inputs: Locale_Ai_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strojový překlad (nezkontrolováno)`)
};

const en_locale_ai_machine = /** @type {(inputs: Locale_Ai_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine-translated (not reviewed)`)
};

/**
* | output |
* | --- |
* | "Machine-translated (not reviewed)" |
*
* @param {Locale_Ai_MachineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const locale_ai_machine = /** @type {((inputs?: Locale_Ai_MachineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Ai_MachineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locale_ai_machine(inputs)
	return cs_locale_ai_machine(inputs)
});